
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const DeleteSelectProducts = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCTS_DELETE_SELECT_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'PRODUCTS_DELETE_SELECT_ERROR':
            return { loading: false, error: true, data: [] };
        case 'PRODUCTS_DELETE_SELECT_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'PRODUCTS_DELETE_SELECT_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default DeleteSelectProducts